import { render } from "./page-error.vue?vue&type=template&id=733c046e"
import script from "./page-error.vue?vue&type=script&lang=js"
export * from "./page-error.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__